/* unplugin-vue-components disabled */import script from "./TodoCalendar.vue?vue&type=script&setup=true&name=TodoCalendar&lang=js"
export * from "./TodoCalendar.vue?vue&type=script&setup=true&name=TodoCalendar&lang=js"

import "./TodoCalendar.vue?vue&type=style&index=0&id=1b1d4e1c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1d4e1c"]])

export default __exports__